import React from "react";
import PropTypes from "prop-types";
import { intlShape, injectIntl } from "react-intl";
import { reduxForm, formValues } from "redux-form";
import { compose } from "ramda";
import moment from "moment";
import { StringField, DateField } from "cxa-form-field";
import { Button, Loader } from "cxa-components";
import messages from "components/messagesDescription";
import { getLatestDate, isBeforeToday } from "cxa-utils/date";
import { isEmpty } from "lodash";

const DATE_FORMAT = moment.localeData().longDateFormat("ll");

const required = value => (value ? undefined : "Required");

const fromDateValidation = (value, _allValues, props) => {
  if (!props.isEditMode && isBeforeToday(value)) {
    return "Cannot choose date before today";
  }
};

const endDateValidation = (value, allValues) => {
  if (isBeforeToday(value)) {
    return "Cannot choose date before today";
  }
  if (
    !isEmpty(allValues.fromDate) &&
    !isEmpty(value) &&
    moment(value).isBefore(moment(allValues.fromDate), "day")
  ) {
    return "To date must be same or after From Date";
  }
};

const AddEditDelegationForm = ({
  error,
  handleSubmit,
  onCheck,
  delegationError,
  submitting,
  onCancel,
  pristine,
  submitFailed,
  intl,
  fromDate,
  isEditMode,
  isChecking,
  invalid,
}) => {
  const todayDate = moment();
  const endMinDate = getLatestDate(fromDate, todayDate);
  const errorMessage = (delegationError && delegationError.message) || (submitFailed && error);
  return (
    <form onSubmit={handleSubmit}>
      <StringField
        type="String"
        id="employeeName"
        readOnly={true}
        disabled={true}
        label={`${intl.formatMessage({ ...messages.delegation.addEdit.delegateTo })}:`}
        name="employeeName"
      />

      <StringField
        id="delegate"
        readOnly={true}
        disabled={true}
        label={`${intl.formatMessage({ ...messages.delegation.addEdit.delegate })}:`}
        name="delegate"
      />

      <DateField
        id="fromDate"
        name="fromDate"
        dateFormat={DATE_FORMAT}
        readOnly={isEditMode}
        disabled={false}
        label={`${intl.formatMessage({ ...messages.delegation.addEdit.fromDate })}:`}
        minDate={todayDate}
        validate={[required, fromDateValidation]}
      />

      <DateField
        id="endDate"
        name="endDate"
        dateFormat={DATE_FORMAT}
        readOnly={false}
        disabled={false}
        label={`${intl.formatMessage({ ...messages.delegation.addEdit.endDate })}:`}
        minDate={endMinDate}
        validate={[endDateValidation]}
      />

      <p className="form__action">
        <Button
          type="button"
          disabled={pristine || submitting || invalid || isChecking}
          onClick={onCheck}
        >
          {intl.formatMessage(messages.saveTextDescription)}
        </Button>

        <Button type="button" disabled={submitting || isChecking} secondary onClick={onCancel}>
          {intl.formatMessage(messages.cancelTextDescription)}
        </Button>

        {isChecking && <Loader />}
      </p>

      {errorMessage && (
        <div className="form__alert alert alert--error">
          {intl.formatMessage({
            id: errorMessage,
            defaultMessage: errorMessage,
          })}
        </div>
      )}
    </form>
  );
};

AddEditDelegationForm.propTypes = {
  handleSubmit: PropTypes.func,
  onCheck: PropTypes.func,
  onCancel: PropTypes.func,
  submitting: PropTypes.bool,
  submitFailed: PropTypes.bool,
  pristine: PropTypes.bool,
  intl: intlShape.isRequired,
  error: PropTypes.string,
  delegationError: PropTypes.object,
  fromDate: PropTypes.string,
  isEditMode: PropTypes.bool.isRequired,
  isChecking: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
};

export const formName = "AddEditDelegationForm";
export default compose(
  injectIntl,
  reduxForm({
    form: formName,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true,
    onSubmit: (values, dispatch, { action }) => action(values),
  }),
  formValues("fromDate")
)(AddEditDelegationForm);



// WEBPACK FOOTER //
// ./components/employee/delegation/AddEditDelegationForm.js